module.exports = __webpack_public_path__ + "ba5f3e8a132e79e397415419a72982de.MP3";